import { render, staticRenderFns } from "./CenterAlignmentPaginationNav.vue?vue&type=template&id=0760335c"
import script from "./CenterAlignmentPaginationNav.vue?vue&type=script&lang=js"
export * from "./CenterAlignmentPaginationNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports